import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide
      autoNext={18000}
      notes="System integration demonstration"
      visualizer="full"
      terminal={{
        phases: [
          {
            type: 'command',
            content: 'eva init --integrate-systems',
          },
          {
            type: 'progress',
            content: 'Connecting to RobotCandy API...',
            duration: 3000,
          },
          {
            type: 'access',
            content: 'API Connection Established',
          },
          {
            type: 'progress',
            content: 'Loading Natural Language Processing modules...',
            duration: 5000,
          },
          {
            type: 'access',
            content: 'NLP Systems Online',
          },
          {
            type: 'progress',
            content: 'Initializing Computer Vision Systems...',
            duration: 6500,
          },
          {
            type: 'access',
            content: 'Vision Systems Ready',
          },
          {
            type: 'progress',
            content: 'Calibrating Voice Recognition...',
            duration: 3500,
          },
          {
            type: 'access',
            content: 'Voice Systems Operational',
          },
          {
            type: 'progress',
            content: 'Syncing with Knowledge Base...',
            duration: 2000,
          },
          {
            type: 'access',
            content: 'Knowledge Integration Complete',
          },
          {
            type: 'access',
            content: 'All Systems Integrated Successfully',
          },
        ],
        config: {
          typingSpeed: 30,
          phaseDelay: 600,
        },
      }}
      transition="fade"
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
